import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/core'
import { SearchX } from 'lucide-react'

import useLocaleText from 'components/useLocaleText'

export interface IEmptyStateProps {
  /** Locale key to look up the main message. Falls back to defaultText. */
  literalKey?: string
  /** Fallback text shown when literalKey is missing or not resolved. */
  defaultText?: string
  /** Optional secondary description line (plain string, not localised). */
  description?: string
  /** Override the default icon (SearchX). Pass null to hide. */
  icon?: React.ReactNode
  /** Icon size in px. Default: 36. */
  iconSize?: number
  /** Extra vertical padding around the whole block. Default: '40px'. */
  py?: string
}

const DEFAULT_TEXT = 'No results found'

export const EmptyState: React.FC<IEmptyStateProps> = ({
  literalKey,
  defaultText = DEFAULT_TEXT,
  description,
  icon,
  iconSize = 36,
  py = '40px',
}) => {
  const localisedText = useLocaleText(literalKey || '')
  const label = literalKey && localisedText ? localisedText : defaultText

  const renderedIcon =
    icon === null ? null : icon !== undefined ? icon : <SearchX size={iconSize} strokeWidth={1.5} color="#CBD5E1" />

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      py={py}
      px="16px"
      style={{ gap: '10px', textAlign: 'center' }}
    >
      {renderedIcon && (
        <Box opacity={0.9} mb="2px">
          {renderedIcon}
        </Box>
      )}
      <Text fontSize="13px" fontWeight="600" color="#94A3B8" lineHeight="1.4">
        {label}
      </Text>
      {description && (
        <Text fontSize="12px" fontWeight="400" color="#CBD5E1" lineHeight="1.5" maxW="260px">
          {description}
        </Text>
      )}
    </Flex>
  )
}
